import type { Member, Video } from '../types.ts';
import { fmtRel, fmtViews } from '../lib/format.ts';
import { youtubeWatchUrl } from '../lib/api.ts';
import { highlight } from '../lib/highlight.tsx';
import { track } from '../lib/track.ts';
import { Thumbnail } from './Thumbnail.tsx';
import { KindBadge } from './KindBadge.tsx';

interface Props {
  video: Video;
  member: Member;
  query: string;
}

export function VideoCard({ video, member, query }: Props) {
  return (
    <a
      className="ss-card"
      href={youtubeWatchUrl(video.id)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => {
        track('video-click', {
          videoId: video.id,
          memberId: video.memberId,
          kind: video.kind,
          hasQuery: query.length > 0,
        });
      }}
    >
      <Thumbnail video={video} member={member} />
      <div className="ss-card__body">
        <div className="ss-card__meta-top">
          <KindBadge kind={video.kind} />
          <span className="ss-card__date">{fmtRel(new Date(video.publishedAt))}</span>
        </div>
        <h3 className="ss-card__title">{highlight(video.title, query)}</h3>
        <div className="ss-card__meta-bottom">
          <div
            className="ss-card__member"
            style={{ ['--mc' as string]: member.color }}
          >
            <span>{member.nameKr}</span>
          </div>
          <span className="ss-card__views">{fmtViews(video.views)}</span>
        </div>
      </div>
    </a>
  );
}
